import type { PermissionRequest } from '../../store/types'
import { useAppStore } from '../../store/app'
import './IdlePromptCard.css'

/// "Your agent is waiting" card. No approve/deny — just surfaces the
/// idle message and offers a dismiss button.
export function IdlePromptCard({
  request,
  onDismiss,
}: {
  request: PermissionRequest
  onDismiss: () => void
}) {
  const agent = useAppStore((s) =>
    s.agentInstances.find((a) => a.id === request.ai_agent_instance_id),
  )
  const message =
    typeof request.tool_input.message === 'string'
      ? request.tool_input.message
      : ''

  return (
    <div className="idle">
      {agent?.name && (
        <div className="idle__badge">{agent.name}</div>
      )}
      <div className="idle__icon" aria-hidden>
        🌙
      </div>
      <div className="idle__title">Your agent is waiting</div>
      <div className="idle__message">{message}</div>
      <div className="idle__spacer" />
      <button className="idle__dismiss" onClick={onDismiss}>
        ✕ Dismiss
      </button>
    </div>
  )
}
